const PROFILE_INDUCTION_STATUS_CHANGED_EVENT = 'cloudloq:profile-induction-status-changed';

export const emitProfileInductionStatusChanged = (payload) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(PROFILE_INDUCTION_STATUS_CHANGED_EVENT, {
      detail: payload,
    })
  );
};

export const subscribeToProfileInductionStatusChanged = (callback) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const handler = (event) => {
    callback(event.detail);
  };

  window.addEventListener(PROFILE_INDUCTION_STATUS_CHANGED_EVENT, handler);

  return () => {
    window.removeEventListener(PROFILE_INDUCTION_STATUS_CHANGED_EVENT, handler);
  };
};
